import { MODIFY_PANEL, SET_PANEL, SET_THEME } from "../actions/actionTypes";

const initialState = {
  panel: {
    show: true,
  }, // e.g., could be "settings", "editor", etc.
  theme: "dark", // e.g., "light" or "dark"
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PANEL:
      return {
        ...state,
        panel: action.payload,
      };

    case MODIFY_PANEL:
      return {
        ...state,
        panel: { ...state?.panel, ...action.payload },
      };
    case SET_THEME:
      return {
        ...state,
        theme: action.payload,
      };
    default:
      return state;
  }
};

export default uiReducer;
